module.exports = window["core-js/modules/es.array.sort.js"];